import Rx from 'rxjs/Rx';


import { BaseController } from '@shared/basecontroller.controller';
import { TRANSACTION_TYPES } from './model/form.model';
import EVENTS from '@shared/events';


import datePicker from '../../../shared/ui/datepicker/datepicker.controller';

import OverviewModel from './model/overview.model';
import FilterForm from './model/form.model';

import numeral from 'numeral';
import moment from 'moment';
import { BITCOIN_DECIMAL_PLACES_FORMAT } from '../../../shared/utils/number.utils';
import { PAYMENT_OPTION_TYPE } from "../../../api/models/payment-option.model";

class OverviewController extends  BaseController {
  constructor(OverviewStore, EventDispatcherService, $timeout, $scope, $translate) {
    'ngInject';

    super();

    this.OverviewStore = OverviewStore;
    this.EventDispatcherService = EventDispatcherService;
    this.$timeout = $timeout;
    this.$scope = $scope;
    this.$translate = $translate;

    this.$scope.$on('reload.transaction-overview', () => {
      this.getTransactionHistory(this.form.toPayload());
    });
  }

  $onInit() {
    this.showForm = false;
    this.model = new OverviewModel();
    this.form = new FilterForm();
    this.subject = new Rx.BehaviorSubject();
    this.picker = new datePicker();

    this.removeSettingsHighlight();
    this.getBalances();
    this.getTransactionHistory(this.form.toPayload());

    this.addSubscription(this.EventDispatcherService.addListener(EVENTS.TRANSACTION_PROCESSED, event => {
      this.getBalances();
      this.getTransactionHistory(this.form.toPayload());
    }));

    this.addSubscription(this.EventDispatcherService.addListener(EVENTS.BET_PROCESSED, event => this.getBalances()));

    this.updateModel();
  }

  renderTable() {
    this.$timeout(() => {
      $('#datatable-responsive').footable();
      $('#datatable-responsive').trigger('footable_redraw');
    }, 0);
  }

  $onDestroy() {
    this.removeSubscriptions();
  }

  updateModel() {
    return this.OverviewStore.getDashboardDetails().then((details) => {
      this.model.verifiedAt = details.others.verifiedAt;
      this.model.status = details.others.verifiedAt ? this.$translate.instant('Verified') : this.$translate.instant('Not Verified');
    });
  }

  getBalances() {
    this.OverviewStore.getBalance().then(response => { this.model.balanceSummary = response; });
    this.OverviewStore.getBalancePerProduct().then(response => this.model.balancePerProduct = response);
    this.form.setPaymentOptions(PAYMENT_OPTION_TYPE);
    this.subscription = this.OverviewStore.getStatuses().subscribe(statuses => this.form.setStatuses(statuses));
    this.currencySubscription = this.OverviewStore.currency$.subscribe(currency => this.userCurrency = currency);
  }

  getTransactionHistory(payload) {  
    this.OverviewStore.getHistory(payload)
    .then((response) => {
      if (!angular.isDefined(response.items)) {
        response.items = [];
      }

      const getStatusLabel = (transaction) => {
        let label = transaction.status.label;

        if (transaction.is_bitcoin_status_pending_confirmation) {
          label = this.$translate.instant('Pending Confirmation');
        } else if (transaction.is_bitcoin_status_confirmed) {
          label = this.$translate.instant('Confirmed');
        }

        if (transaction.is_voided) {
          label = this.$translate.instant('Voided');
        }

        return label;
      }
      
      const getCommissionPeriod = (transaction) => {
        let commissionPeriod = null;

        if (typeof transaction.commission_period !== 'undefined') {
            commissionPeriod = {
                'payoutAt': moment(transaction.commission_period.payoutAt).format('MM/DD/YYYY'),
                'dateFrom': moment(transaction.commission_period.dateFrom).format('MM/DD/YYYY'),
                'dateTo': moment(transaction.commission_period.dateTo).format('MM/DD/YYYY')
            };
        }

        return commissionPeriod;
      };

      const getRevenueSharePeriod = (transaction) => {
        let revenueSharePeriod = null;

        if (typeof transaction.revenue_share_period !== 'undefined') {
            revenueSharePeriod = {
                'payoutAt': moment(transaction.revenue_share_period.payoutAt).format('MM/DD/YYYY'),
                'dateFrom': moment(transaction.revenue_share_period.dateFrom).format('MM/DD/YYYY'),
                'dateTo': moment(transaction.revenue_share_period.dateTo).format('MM/DD/YYYY')
            };
        }

        return revenueSharePeriod;
      };

      this.model.transactionTable.transactions = response.items.map((transaction) => {
        const item = {
          date: transaction.date,
          transactionNumber: transaction.number,
          type: TRANSACTION_TYPES[transaction.type],
          currency: transaction.currency.code === 'BTC' ? 'EUR' : transaction.currency.code,
          isReceiver: transaction.productDetails.isReceiver,
          customerProductFrom: transaction.productDetails.from,
          customerProductTo: transaction.productDetails.to,
          paymentOption: transaction.payment_option ? transaction.payment_option.type : 'N/A',
          amount: transaction.amount,
          customerFee: transaction.customer_fee,
          customerAmount: transaction.customer_amount,
          status: getStatusLabel(transaction),
          voidingReason: transaction.voiding_reason,
          isVoidedDeclined: transaction.status.id === 3 ? true : transaction.is_voided,
          commissionConvertions: transaction.commission_convertions,
          commissionPeriod: getCommissionPeriod(transaction),
          revenueShareConversions: transaction.revenue_share_conversions,
          revenueSharePeriod: getRevenueSharePeriod(transaction),
          notes: transaction.notes_in_details,
          isAdjustment: transaction.type == 10 || transaction.type == 11 ? true : false,
          isProcessed: transaction.status.id == 2 ? true : false,
          isBitcoin: transaction.is_transaction_payment_bitcoin,
          totalBitcoinAmount: numeral(transaction.bitcoin_total_amount).format(BITCOIN_DECIMAL_PLACES_FORMAT)
        };

        item.displayAmount = function() {
          if (this.isBitcoin && !(numeral(0).format(BITCOIN_DECIMAL_PLACES_FORMAT) === this.totalBitcoinAmount)) {
            return `${this.amount} (${this.totalBitcoinAmount} BTC)`;
          }
  
          if (this.type === 'WITHDRAWAL') {
            return this.customerAmount;
          }

          return this.amount;
        }

        return item;
      });
    
      this.model.transactionTable.pagination = {
        limit: Number(response.limit),
        page: Number(response.page),
        total: Number(response.total),
        totalFiltered: Number(response.total_filtered)
      };

      this.subject.next(this.model.transactionTable.pagination);

      this.renderTable();
    });
  }

  submit() {
    this.form.page = null;
    this.getTransactionHistory(this.form.toPayload());
  }

  reset() {
    this.picker.onReset();
    this.form.reset();
    this.submit();
  }

  paginate(page) {
    this.form.page = page.number;
    this.getTransactionHistory(this.form.toPayload());
  }

  refreshBalance() {
    this.OverviewStore.getBalance().then(response => this.model.balanceSummary = response);
    this.OverviewStore.getBalancePerProduct().then(response => this.model.balancePerProduct = response);
  }

  getFirstLabel(type, customerAmount, amount) {
    if (type === 'DEPOSIT') {
      return this.$translate.instant('Total amount to be deposited on account') + ': ' + customerAmount;
    } else if (type === 'WITHDRAWAL') {
      return this.$translate.instant('Total amount to be deducted from account') + ': ' + amount;
    }
  }

  getSecondLabel(type, customerAmount, amount) {
    if (type === 'DEPOSIT') {
      return this.$translate.instant('Total amount to be sent') + ': ' + amount;
    } else if (type === 'WITHDRAWAL') {
      return this.$translate.instant('Total amount to be received') + ': ' + customerAmount;
    }
  }

  withBreakdown(type, fee) {
    if (!(type === 'DEPOSIT' || type === 'WITHDRAWAL')) {
      return false;
    }

    if (fee === 0) {
      return false;
    }

    return true;
  }

  isCommission(type) {
    return type === 'COMMISSION';
  }

  isRevenueShare(type) {
    return type === 'REVENUE SHARE';
  }

  fixAmount(amount) {
    return eval(amount);
  }

  onCustomerProductsLoaded(customerProductsList) {
    this.model.balance.available = customerProductsList.balance;
  }

  removeSettingsHighlight() {
    this.$timeout(() => {
      $('#settings').removeClass('subdrop');
    }, 100);
  }
}

export default OverviewController;



// WEBPACK FOOTER //
// ./client/app/pages/customer/overview/overview.controller.js